import type { LifeEvent } from '@/data/sources/lifeEvents';

export interface FocusSegment {
  name: string;
  start: Date;
  end: Date;
  ongoing: boolean;
}

export const buildFocusSegments = (
  events: LifeEvent[],
  windowStart: Date,
  windowEnd: Date
): FocusSegment[] => {
  const segments: FocusSegment[] = [];
  let open: { name: string; start: Date } | null = null;

  for (const event of events) {
    if (!event.focus) continue;
    const name = event.focus.isActive ? event.focus.name : null;
    if (open) {
      if (open.name === name) continue;
      segments.push({
        name: open.name,
        start: open.start,
        end: event.eventTime,
        ongoing: false,
      });
      open = null;
    } else if (!name) {
      continue;
    }
    if (name) {
      open = { name, start: event.eventTime };
    }
  }

  if (open) {
    segments.push({
      name: open.name,
      start: open.start,
      end: windowEnd,
      ongoing: true,
    });
  }

  return segments.filter((segment) => segment.end > windowStart);
};

export const currentFocus = (events: LifeEvent[]) => {
  for (let i = events.length - 1; i >= 0; i--) {
    const focus = events[i].focus;
    if (focus) return focus.isActive && focus.name ? focus.name : null;
  }
  return null;
};
